import {
  START_LOADING,
  END_LOADING,
  FETCH_DOCTORS,
  FETCH_DOCTOR,
  CREATE_DOCTOR,
  UPDATE_DOCTOR,
  DELETE_DOCTOR,
  FETCH_PATIENTS,
  FETCH_PATIENT,
  CREATE_PATIENT,
  UPDATE_PATIENT,
  DELETE_PATIENT,
  FETCH_APPOINTMENTS,
  FETCH_APPOINTMENT,
  CREATE_APPOINTMENT,
  UPDATE_APPOINTMENT,
  DELETE_APPOINTMENT,
  FETCH_LAB_RESULTS,
  FETCH_LAB_RESULT,
  CREATE_LAB_RESULT,
  UPDATE_LAB_RESULT,
  DELETE_LAB_RESULT,
  FETCH_LAB_TESTS,
  FETCH_LAB_TEST,
  CREATE_LAB_TEST,
  UPDATE_LAB_TEST,
  DELETE_LAB_TEST,
  CLEAR_LAB_TEST,
  FETCH_MEDICAL_RECORDS,
  FETCH_MEDICAL_RECORD,
  CREATE_MEDICAL_RECORD,
  UPDATE_MEDICAL_RECORD,
  DELETE_MEDICAL_RECORD,
  FETCH_MEDICAL_SERVICES,
  FETCH_MEDICAL_SERVICE,
  CREATE_MEDICAL_SERVICE,
  UPDATE_MEDICAL_SERVICE,
  DELETE_MEDICAL_SERVICE,
  FETCH_MEDICATIONS,
  FETCH_MEDICATION,
  CREATE_MEDICATION,
  UPDATE_MEDICATION,
  DELETE_MEDICATION,
  CLEAR_MEDICATION,
  FETCH_PRESCRIPTIONS,
  FETCH_PRESCRIPTION,
  CREATE_PRESCRIPTION,
  UPDATE_PRESCRIPTION,
  DELETE_PRESCRIPTION,
  CLEAR_PRESCRIPTION
} from '../actions/constants';

const initialState = {
  doctors: [],
  patients: [],
  appointments: [],
  labResults: [],
  labTests: [],
  medicalRecords: [],
  medicalServices: [],
  medications: [],
  prescriptions: [],
  currentDoctor: null,
  currentPatient: null,
  currentAppointment: null,
  currentLabResult: null,
  currentLabTest: null,
  currentMedicalRecord: null,
  currentMedicalService: null,
  currentMedication: null,
  currentPrescription: null,
  loading: false
};

const clinicReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, loading: true };
    case END_LOADING:
      return { ...state, loading: false };
      
    // Doctor actions
    case FETCH_DOCTORS:
      return { ...state, doctors: action.payload };
    case FETCH_DOCTOR:
      return { ...state, currentDoctor: action.payload };
    case CREATE_DOCTOR:
      return { ...state, doctors: [...state.doctors, action.payload] };
    case UPDATE_DOCTOR:
      return { 
        ...state, 
        doctors: state.doctors.map(doctor => doctor._id === action.payload._id ? action.payload : doctor),
        currentDoctor: action.payload
      };
    case DELETE_DOCTOR:
      return { ...state, doctors: state.doctors.filter(doctor => doctor._id !== action.payload) };
      
    // Patient actions
    case FETCH_PATIENTS:
      return { ...state, patients: action.payload };
    case FETCH_PATIENT:
      return { ...state, currentPatient: action.payload };
    case CREATE_PATIENT:
      return { ...state, patients: [...state.patients, action.payload] };
    case UPDATE_PATIENT:
      return { 
        ...state, 
        patients: state.patients.map(patient => patient._id === action.payload._id ? action.payload : patient),
        currentPatient: action.payload
      };
    case DELETE_PATIENT:
      return { ...state, patients: state.patients.filter(patient => patient._id !== action.payload) };
      
    // Appointment actions
    case FETCH_APPOINTMENTS:
      return { ...state, appointments: action.payload };
    case FETCH_APPOINTMENT:
      return { ...state, currentAppointment: action.payload };
    case CREATE_APPOINTMENT:
      return { ...state, appointments: [...state.appointments, action.payload] };
    case UPDATE_APPOINTMENT:
      return { 
        ...state, 
        appointments: state.appointments.map(appointment => appointment._id === action.payload._id ? action.payload : appointment),
        currentAppointment: action.payload
      };
    case DELETE_APPOINTMENT:
      return { ...state, appointments: state.appointments.filter(appointment => appointment._id !== action.payload) };
      
    // Lab Result actions
    case FETCH_LAB_RESULTS:
      return { ...state, labResults: action.payload };
    case FETCH_LAB_RESULT:
      return { ...state, currentLabResult: action.payload };
    case CREATE_LAB_RESULT:
      return { ...state, labResults: [...state.labResults, action.payload] };
    case UPDATE_LAB_RESULT:
      return { 
        ...state, 
        labResults: state.labResults.map(result => result._id === action.payload._id ? action.payload : result),
        currentLabResult: action.payload
      };
    case DELETE_LAB_RESULT:
      return { ...state, labResults: state.labResults.filter(result => result._id !== action.payload) };
      
    // Lab Test actions
    case FETCH_LAB_TESTS:
      return { ...state, labTests: action.payload };
    case FETCH_LAB_TEST:
      return { ...state, currentLabTest: action.payload };
    case CREATE_LAB_TEST:
      return { ...state, labTests: [...state.labTests, action.payload] };
    case UPDATE_LAB_TEST:
      return { 
        ...state, 
        labTests: state.labTests.map(test => test._id === action.payload._id ? action.payload : test),
        currentLabTest: action.payload
      };
    case DELETE_LAB_TEST:
      return { ...state, labTests: state.labTests.filter(test => test._id !== action.payload) };
    case CLEAR_LAB_TEST:
      return { ...state, currentLabTest: null };
      
    // Medical Record actions
    case FETCH_MEDICAL_RECORDS:
      return { ...state, medicalRecords: action.payload };
    case FETCH_MEDICAL_RECORD:
      return { ...state, currentMedicalRecord: action.payload };
    case CREATE_MEDICAL_RECORD:
      return { ...state, medicalRecords: [...state.medicalRecords, action.payload] };
    case UPDATE_MEDICAL_RECORD:
      return { 
        ...state, 
        medicalRecords: state.medicalRecords.map(record => record._id === action.payload._id ? action.payload : record),
        currentMedicalRecord: action.payload
      };
    case DELETE_MEDICAL_RECORD:
      return { ...state, medicalRecords: state.medicalRecords.filter(record => record._id !== action.payload) };
      
    // Medical Service actions
    case FETCH_MEDICAL_SERVICES:
      return { ...state, medicalServices: action.payload };
    case FETCH_MEDICAL_SERVICE:
      return { ...state, currentMedicalService: action.payload };
    case CREATE_MEDICAL_SERVICE:
      return { ...state, medicalServices: [...state.medicalServices, action.payload] };
    case UPDATE_MEDICAL_SERVICE:
      return { 
        ...state, 
        medicalServices: state.medicalServices.map(service => service._id === action.payload._id ? action.payload : service),
        currentMedicalService: action.payload
      };
    case DELETE_MEDICAL_SERVICE:
      return { ...state, medicalServices: state.medicalServices.filter(service => service._id !== action.payload) };
      
    // Medication actions
    case FETCH_MEDICATIONS:
      return { ...state, medications: action.payload };
    case FETCH_MEDICATION:
      return { ...state, currentMedication: action.payload };
    case CREATE_MEDICATION:
      return { ...state, medications: [...state.medications, action.payload] };
    case UPDATE_MEDICATION:
      return { 
        ...state, 
        medications: state.medications.map(medication => medication._id === action.payload._id ? action.payload : medication),
        currentMedication: action.payload
      };
    case DELETE_MEDICATION:
      return { ...state, medications: state.medications.filter(medication => medication._id !== action.payload) };
    case CLEAR_MEDICATION:
      return { ...state, currentMedication: null };
      
    // Prescription actions
    case FETCH_PRESCRIPTIONS:
      return { ...state, prescriptions: action.payload };
    case FETCH_PRESCRIPTION:
      return { ...state, currentPrescription: action.payload };
    case CREATE_PRESCRIPTION:
      return { ...state, prescriptions: [...state.prescriptions, action.payload] };
    case UPDATE_PRESCRIPTION:
      return { 
        ...state, 
        prescriptions: state.prescriptions.map(prescription => prescription._id === action.payload._id ? action.payload : prescription),
        currentPrescription: action.payload
      };
    case DELETE_PRESCRIPTION:
      return { ...state, prescriptions: state.prescriptions.filter(prescription => prescription._id !== action.payload) };
    case CLEAR_PRESCRIPTION:
      return { ...state, prescription: null };
      
    default:
      return state;
  }
};

export default clinicReducer;
